import { render, staticRenderFns } from "./Error.ts.vue?vue&type=template&id=a8ee5a5c&"
import script from "./Error.ts.vue?vue&type=script&lang=ts&"
export * from "./Error.ts.vue?vue&type=script&lang=ts&"
import style0 from "./Error.ts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports